import { loadBrandListerReducer } from '../../brandLister/reducers/BrandListerReducer';
import brandListerSaga from '../../brandLister/sagas/BrandListerSagas';
const loadBrandListerSubModule = (initialData) => ({
    id: 'BrandLister',
    reducerMap: {
        brandLister: loadBrandListerReducer(initialData ? initialData.brandLister : null),
    },
    sagas: [brandListerSaga],
});
export default loadBrandListerSubModule;
